var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wrs-label',{attrs:{"label":_vm.valueItem.label,"value":_vm.model,"isHighlighted":_vm.isHighlighted,"highLightColor":_vm.highLightColor}})
}
var staticRenderFns = []

export { render, staticRenderFns }